<script lang="ts" setup>
import { ref } from 'vue';
import { useBroadcast } from '~/stores/broadcast.store';

const broadcastStore = useBroadcast();

const isSending = ref(false);

const cancel = () => {
  broadcastStore.setVisibleConfirmModal(false);
};
const onConfirm = async () => {
  if (isSending.value) return;
  isSending.value = true;

  await broadcastStore.create();

  isSending.value = false;
};
</script>

<template>
  <el-dialog
    :model-value="broadcastStore.getVisibleConfirmModal"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    width="560px"
  >
    <div class="dialog">
      <div class="dialog-header">
        <p class="title">{{ $t('broadcast.modal.confirmWaited.title') }}</p>
      </div>

      <div class="dialog-info">
        <p class="description">{{ $t('broadcast.modal.confirmWaited.description') }}</p>
        <br />
        <p class="description">{{ $t('broadcast.modal.confirmWaited.hasQueue') }}</p>
      </div>

      <div class="dialog-footer">
        <el-button @click="cancel" class="cancel">
          {{ $t('common.cancel') }}
        </el-button>

        <el-button @click="onConfirm" :class="['confirm', { disabled: isSending }]">
          {{ $t('common.send') }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.dialog {
  padding: 24px;
  box-sizing: border-box;

  &-header {
    .title {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      color: $typography-title;
    }
  }

  &-info {
    margin-top: 18px;
    width: 512px;

    .description {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: $typography-secondary-color;
      white-space: pre-line;
    }
  }

  &-footer {
    border-radius: 0 0 4px 4px;
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;

    button {
      padding: 18px 16px;
      font-family: 'Roboto';
      letter-spacing: 0.89px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }

    .confirm {
      border: none;
      color: $ui-white;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-transform: uppercase;
      background: $ui-accent;

      &:hover {
        color: $ui-white;
        background: $ui-accent;
      }
    }
    .disabled {
      opacity: 0.26;
    }

    .cancel {
      color: $ui-accent;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      background: $ui-white;
      padding: 12px 16px;
      border: none;
      text-transform: uppercase;
    }
  }
}
</style>
